import * as request from './genericRequest';

const ConsumerGroupsRoute = 'consumerGroups';

export const getAllConsumerGroups = async () => request.getApi(ConsumerGroupsRoute);
export const getConsumerGroupsByConsumerId = async (consumerId) => request.getApi(`${ConsumerGroupsRoute}/${consumerId}`);
export const resetConsumerGroupById = async (id) => request.putApi(`${ConsumerGroupsRoute}/reset/${id}`, id);
